import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { contentRoot } from '../config'
import localization from '../helpers/localization'
const askPlanTypePage = ({onSelectDesingPath,onSelectOnlyContactPath
   }) => {

    return (<div className="page">
        <Row>
            <Col className="planTypeSelection" sm={6} onClick={onSelectDesingPath}>
                <img className="img-fluid" src={contentRoot + "img/suunnittelu.png"}></img>
                <div className="orangeButton buttonTxt" dangerouslySetInnerHTML={{ __html: localization.wantToDesign }}> 
                </div>
                <p dangerouslySetInnerHTML={{ __html: localization.designPathDescription }}></p>
            </Col>
            <Col className="planTypeSelection" sm={6}  onClick={onSelectOnlyContactPath}>
                <img className="img-fluid" src={contentRoot + "img/lataa.png"}></img>
                <div className="orangeButton buttonTxt"
                    dangerouslySetInnerHTML={{ __html: localization.wantToLeaveContactDetails }}> 
                </div>
                <p dangerouslySetInnerHTML={{ __html: localization.contactPathDescription }}>
        
                </p>
            </Col>
        </Row>
    </div>
    )
}
export default askPlanTypePage

